import { render } from "./ExternalApiKeyCreatedModal.vue?vue&type=template&id=70570bd8"
import script from "./ExternalApiKeyCreatedModal.vue?vue&type=script&lang=js"
export * from "./ExternalApiKeyCreatedModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__